import { useState } from "react";

import { KeywordSearch } from "@/types/search";

import { isNotEmpty } from "@/libs/utils";

import CommonInput from "../Common/Input";
import CommonPlusButton from "../Common/PlusButton";
import CommonSelect from "../Common/Select";

import KeywordItem from "@/components/KeywordItem";

type Props = {
  data: KeywordSearch;
  setData: (data: KeywordSearch) => void;
};
export default function KeywordSearchItem({ data, setData }: Props) {
  const [inputText, setInputText] = useState<string>("");

  const handleClickPlus = () => {
    if (isNotEmpty(inputText)) {
      setData({ ...data, input_strings: data.input_strings.concat(inputText) });
      setInputText("");
    }
  };
  const handleDeleteItem = (index: number) => {
    setData({ ...data, input_strings: data.input_strings.toSpliced(index, 1) });
  };

  return (
    <div className="flex gap-[8px]">
      <CommonSelect
        className="min-w-[92px]"
        useAll={false}
        defaultValue={data.title_or_doc}
        optionList={[
          { label: "공고 제목", value: "TITLE" },
          { label: "첨부 파일 본문", value: "DOC" },
        ]}
        onChange={(value: any) => {
          setData({ ...data, title_or_doc: value });
        }}
      />
      <CommonSelect
        className="min-w-[56px]"
        useAll={false}
        defaultValue={data.or_and}
        optionList={[
          { label: "OR", value: "OR" },
          { label: "AND", value: "AND" },
        ]}
        onChange={(value: any) => {
          setData({ ...data, or_and: value });
        }}
      />
      <CommonInput
        className="min-w-[180px]"
        placeholder="키워드를 입력해보세요"
        defaultValue={inputText}
        onChange={(value) => {
          setInputText(value);
        }}
        onKeyDownEnter={() => {
          handleClickPlus();
        }}
      />
      <CommonPlusButton onClick={handleClickPlus} />
      <div className="flex gap-[8px] overflow-x-auto">
        {data.input_strings.map((input, inputIndex) => (
          <KeywordItem
            key={inputIndex}
            index={inputIndex}
            label={input}
            onDelete={() => handleDeleteItem(inputIndex)}
          />
        ))}
      </div>
    </div>
  );
}
